import DeepRoom from './pages/DeepRoom.vue';
import DeepDefault from './pages/DeepDefault.vue';
import { DeepRoute } from './constants';

export const deepLinkRouterSegment = [
  { ...DeepRoute.CALL, component: DeepDefault },
  { ...DeepRoute.ROOM, component: DeepRoom },
  { ...DeepRoute.RESET_PASSWORD,  component: DeepDefault },
  { ...DeepRoute.PAYMENT, component: DeepDefault },
  { ...DeepRoute.PAYMENT_SUCCESS, component: DeepDefault },
  { ...DeepRoute.AUTH, component: DeepDefault },
];